import React from "react"

const ErrorHelper = {
  renderErrors: function (errors, field_names) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(<li key={i}>{errors.base[i]}</li>);
      }
    }

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]];
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(<li key={i + '_' + field_errors[j]}>{I18n.t(field_names[i])} {field_errors[j]}</li>);
        }
      }
    }

    if (err && err.length > 0) {
      return (
        <div className="alert alert-danger">
          <ul>{err}</ul>
        </div>
      )
    } else {
      return null
    }
  },

  tabErrorCount: function (errors, field_names) {
    return field_names.reduce((acc, fn) => {
      errors[fn] ? acc += 1 : null
      return acc
    }, 0);
  },

  renderFieldErrors(field, errors) {
    if (errors && errors[field]) {
      var idx = 0
      var fieldErrors = errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      })
      return (
        <div className="help-block">
          <ul>{fieldErrors}</ul>
        </div>
      )
    }
  },

  renderFieldClasses(field, errors, classname) {
    var classname = classname || ''
    if (errors && Object.keys(errors).length && errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  },

  renderFieldClassesRow(field, errors) {
    var classname = 'row'
    if (errors && Object.keys(errors).length && errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }
}

export default ErrorHelper